// src/config.js
export const BASE_URL = 'https://ugobueze-app.onrender.com';

// Additional configuration values can be added here in the future, e.g.:
// export const API_TIMEOUT = 5000;
// export const API_KEY = 'your-api-key';